<template>
    <div class="letter-page">
        <div class="letter-card">
            <!-- 信头 -->
            <header class="letter-head">
                <div class="head-orn">✿</div>
                <h1 class="letter-title">{{ title }}</h1>
                <div class="letter-date" v-if="date">{{ date }}</div>
            </header>

            <!-- 正文：逐段渐入 -->
            <div class="letter-body">
                <p
                    class="letter-p"
                    v-for="(p, i) in paragraphs"
                    :key="i"
                    :style="{ animationDelay: 0.15 + i * 0.12 + 's' }"
                >{{ p }}</p>
            </div>

            <!-- 分隔装饰 -->
            <div class="letter-divider"><span>❦</span></div>

            <!-- 落款 -->
            <footer class="letter-sign">
                <span class="sign-name">{{ sign }}</span>
                <span class="sign-date" v-if="signDate">——{{ signDate }}</span>
            </footer>
        </div>

        <!-- 返回列表 -->
        <div class="letter-back" v-if="showBack" @click="goBack">
            <span class="back-ico">‹</span> 返回列表
        </div>
    </div>
</template>

<script>
export default {
    name: 'LetterLayout',
    props: {
        title: { type: String, default: '' },
        date: { type: String, default: '' },
        sign: { type: String, default: '大大大混蛋-----玲' },
        signDate: { type: String, default: '' },
        paragraphs: { type: Array, default: () => [] },
        showBack: { type: Boolean, default: true }
    },
    methods: {
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.push('/forzl');
            }
        }
    }
};
</script>

<style lang="less" scoped>
.letter-page {
    min-height: 100vh;
    box-sizing: border-box;
    padding: 40px 30px 60px;
    background: linear-gradient(180deg, #fdf3e7 0%, #f9ead8 45%, #f5e2cc 100%);
}

.letter-card {
    max-width: 640px;
    margin: 0 auto;
    background: rgba(255, 255, 255, 0.92);
    border: 1px solid rgba(176, 141, 110, 0.25);
    border-radius: 16px;
    box-shadow: 0 8px 30px rgba(150, 110, 70, 0.14);
    padding: 50px 36px 44px;
}

/* ---------- 信头 ---------- */
.letter-head {
    text-align: center;
    margin-bottom: 40px;
}
.head-orn {
    font-size: 28px;
    color: #d8a48f;
    margin-bottom: 16px;
}
.letter-title {
    margin: 0;
    font-size: 40px;
    font-weight: 600;
    color: #5b4636;
    letter-spacing: 2px;
    line-height: 1.5;
}
.letter-date {
    display: inline-block;
    margin-top: 20px;
    font-size: 24px;
    color: #b08d6e;
    background: rgba(176, 141, 110, 0.12);
    padding: 6px 24px;
    border-radius: 999px;
}

/* ---------- 正文 ---------- */
.letter-body {
    margin-top: 10px;
}
.letter-p {
    margin: 0 0 28px;
    font-size: 30px;
    line-height: 1.9;
    color: #4a3f35;
    text-align: justify;
    text-indent: 2em;
    word-break: break-all;
    opacity: 0;
    animation: pIn 0.6s ease forwards;
}
@keyframes pIn {
    from {
        opacity: 0;
        transform: translateY(14px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* ---------- 分隔 ---------- */
.letter-divider {
    display: flex;
    align-items: center;
    margin: 46px 0 30px;
    &::before,
    &::after {
        content: '';
        flex: 1;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(176, 141, 110, 0.5));
    }
    &::after {
        background: linear-gradient(90deg, rgba(176, 141, 110, 0.5), transparent);
    }
    span {
        padding: 0 24px;
        font-size: 28px;
        color: #c69c7b;
    }
}

/* ---------- 落款 ---------- */
.letter-sign {
    text-align: right;
    .sign-name {
        display: block;
        font-family: 'STKaiti', 'KaiTi', '楷体', serif;
        font-size: 34px;
        color: #7a5c44;
        letter-spacing: 2px;
    }
    .sign-date {
        display: block;
        margin-top: 12px;
        font-size: 26px;
        color: #a08a76;
    }
}

/* ---------- 返回 ---------- */
.letter-back {
    max-width: 640px;
    margin: 36px auto 0;
    text-align: center;
    font-size: 28px;
    color: #9b7a5c;
    background: rgba(255, 255, 255, 0.75);
    border: 1px solid rgba(176, 141, 110, 0.35);
    border-radius: 999px;
    padding: 16px 0;
    .back-ico {
        font-size: 32px;
        margin-right: 8px;
        vertical-align: -2px;
    }
    &:active {
        background: rgba(255, 255, 255, 1);
    }
}
</style>
